import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

const VehicleRegNumberModal = ({ show, onClose, onSave}) => {          
    return (
        <div
          className={`modal fade ${show ? "show" : "hide"}`}
          style={{ display: show ? "block" : "none" }}
          id="modal-lg"
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Vehicle Registration Number</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" onClick={() => onClose()}>
                    ×
                  </span>
                </button>
              </div>
              <div className="modal-body">
                  <h6><b>These vehicle registration number already exist. Do you still want to place a new order?</b></h6>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                  onClick={() => onClose()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => onSave()}
                >
                  Yes, Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      );
};

export default VehicleRegNumberModal;
